module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "appetizers-all-the-young-dudes-cooking-the-foods"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "baked-zeppelin-parmesan-zucchini-sticks"
    }
  }, [_c('h3', [_vm._v("Baked Zeppelin Parmesan Zucchini Sticks")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Trade your drumsticks in for these babies. This hearty and healthy appetizer is like a "), _c('strong', [_c('em', [_vm._v("Stairway to Heaven")])]), _vm._v(".")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "uri"
  }, [_vm._v("https://www.youtube.com/watch?v=xbhCPt6PZIU")])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.86034in",
      "height": "4.04167in"
    },
    attrs: {
      "alt": "",
      "src": "media/fil4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A plate of food Description automatically generated with medium confidence")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Ingredients")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("3 medium zucchinis cut in sticks")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1 cup homemade breadcrumbs (breadcrumbs made from egg and bread. It gives them a nice yellow colour)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup Parmesan cheese grated")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1 egg")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/4 tsp salt for taste")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/4 tsp pepper for taste")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Ranch dressing optional")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Instructions")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("1. ")]), _vm._v("Preheat oven to 425 degrees F/220°C. Prepare a baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("2. ")]), _vm._v("I used 3 medium zucchini which I cut in half then each half in half lengthwise, and then each quarter in half again; so you end up with 8 sticks from one zucchini.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("3. ")]), _vm._v("Beat the egg in a shallow plate. Season the egg with salt and pepper. In another shallow plate, mix the Panko breadcrumbs together with the Parmesan cheese. Season it with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("4. ")]), _vm._v("Dip each zucchini stick in the egg wash, and then roll through the breadcrumb mixture, making sure each stick is fully covered with the breadcrumbs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("5. ")]), _vm._v("Bake for about 20 minutes or until golden brown and crispy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("6. ")]), _vm._v("Serve it with Ranch dressing, blue cheese dressing or Marinara sauce.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd6db54c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0005.vue
// module id = 93
// module chunks = 0